import React, { useState } from 'react';
import LoginAuditTable from './LoginAuditTable';
import BlockedAttemptsTable from './BlockedAttemptsTable';
import McpBlockedTable from './McpBlockedTable';
import McpAccessTable from './McpAccessTable';
import HorizonAccessTable from './HorizonAccessTable';
import TranscriptionPanel from './TranscriptionPanel';
import LifecycleLedgerTable from './LifecycleLedgerTable';
import AskLogPanel from './AskLogPanel';

type LogsTab = 'login_audit' | 'blocked' | 'mcp_blocked' | 'mcp_access' | 'horizon_access' | 'transcription' | 'lifecycle' | 'ask';

const LogsPage: React.FC = () => {
  const [tab, setTab] = useState<LogsTab>('login_audit');

  return (
    <div className="settings-container">
      <nav className="settings-subnav">
        <button className={`nav-button ${tab === 'login_audit' ? 'active' : ''}`} onClick={() => setTab('login_audit')}>
          Login Audit Log
        </button>
        <button className={`nav-button ${tab === 'blocked' ? 'active' : ''}`} onClick={() => setTab('blocked')}>
          Blocked SIP/RTP
        </button>
        <button className={`nav-button ${tab === 'mcp_blocked' ? 'active' : ''}`} onClick={() => setTab('mcp_blocked')}>
          Blocked MCP
        </button>
        <button className={`nav-button ${tab === 'mcp_access' ? 'active' : ''}`} onClick={() => setTab('mcp_access')}>
          MCP Access
        </button>
        <button className={`nav-button ${tab === 'horizon_access' ? 'active' : ''}`} onClick={() => setTab('horizon_access')}>
          Horizon Access
        </button>
        <button className={`nav-button ${tab === 'transcription' ? 'active' : ''}`} onClick={() => setTab('transcription')}>
          Transcription
        </button>
        <button className={`nav-button ${tab === 'ask' ? 'active' : ''}`} onClick={() => setTab('ask')}>
          Ask
        </button>
        <button className={`nav-button ${tab === 'lifecycle' ? 'active' : ''}`} onClick={() => setTab('lifecycle')}>
          Lifecycle Ledger
        </button>
      </nav>

      {tab === 'login_audit' && <LoginAuditTable />}
      {tab === 'blocked' && <BlockedAttemptsTable />}
      {tab === 'mcp_blocked' && <McpBlockedTable />}
      {tab === 'mcp_access' && <McpAccessTable />}
      {tab === 'horizon_access' && <HorizonAccessTable />}
      {tab === 'transcription' && <TranscriptionPanel />}
      {tab === 'ask' && <AskLogPanel />}
      {tab === 'lifecycle' && <LifecycleLedgerTable />}
    </div>
  );
};

export default LogsPage;
